// Global Theme JS

window.theme = window.theme || {};

(function() {
  // Drawer logic
  const drawerOverlay = document.getElementById('CartDrawerOverlay');
  const drawer = document.getElementById('CartDrawer');
  const drawerCloseBtn = document.getElementById('CartDrawerClose');
  const cartIcons = document.querySelectorAll('.cart-icon-btn');
  const drawerContinueBtn = document.getElementById('CartDrawerContinue');

  function openDrawer() {
    if(drawer) drawer.classList.add('open');
    if(drawerOverlay) drawerOverlay.classList.add('open');
  }

  function closeDrawer() {
    if(drawer) drawer.classList.remove('open');
    if(drawerOverlay) drawerOverlay.classList.remove('open');
  }

  if(drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeDrawer);
  if(drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);
  if(drawerContinueBtn) drawerContinueBtn.addEventListener('click', closeDrawer);
  cartIcons.forEach(icon => {
    icon.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer();
    });
  });

    // Fetch cart data
  function fetchCart() {
    return fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartCount = document.getElementById('CartCount');
        if (cartCount) cartCount.innerText = cart.item_count;
        updateDrawerUI(cart);
        return cart;
      });
  }


  function updateDrawerUI(cart) {
    const itemsContainer = document.getElementById('CartDrawerItems');
    const subtotal = document.getElementById('CartDrawerSubtotal');
    
    if(!itemsContainer) return;

    if(cart.items.length === 0) {
      itemsContainer.innerHTML = '<p class="empty-cart-msg">Your cart is empty.</p>';
    } else {
      let html = '';
      cart.items.forEach(item => {
        html += `
          <div class="cart-drawer-item" data-key="${item.key}">
            <div class="cart-item-img-wrapper">
              ${item.image ? `<img src="${item.image}" alt="${item.title}" />` : '<span>Img</span>'}
            </div>
            <div class="cart-item-info">
              <div class="cart-item-title-row">
                <h4>${item.product_title}</h4>
                <span class="cart-item-price">R${(item.final_line_price / 100).toFixed(2)}</span>
              </div>
              <p class="cart-item-variant">${item.variant_title ? item.variant_title : ''}</p>
              
              <div class="cart-item-actions">
                            <div class="cart-qty-selector">
              <button type="button" class="cart-qty-btn cart-qty-minus" onclick="window.theme.updateCartItem('${item.key}', ${item.quantity - 1})">-</button>
              <input class="cart-qty-input" type="number" value="${item.quantity}" readonly />
              <button type="button" class="cart-qty-btn cart-qty-plus" onclick="window.theme.updateCartItem('${item.key}', ${item.quantity + 1})">+</button>
            </div>
            <button class="cart-trash-btn" onclick="window.theme.updateCartItem('${item.key}', 0)">
              <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
            </button>

              </div>
            </div>
          </div>
        `;
      });
      itemsContainer.innerHTML = html;
    }
    
    if(subtotal) subtotal.innerText = 'R' + (cart.total_price / 100).toFixed(2);
  }

    window.theme.updateCartItem = function(key, quantity) {
    const itemsContainer = document.getElementById('CartDrawerItems');
    if (itemsContainer) itemsContainer.style.opacity = '0.5';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: String(quantity) })
    })
    .then(res => res.json())
    .then(cart => {
      const cartCount = document.getElementById('CartCount');
      if (cartCount) cartCount.innerText = cart.item_count;
      updateDrawerUI(cart);
      if (itemsContainer) itemsContainer.style.opacity = '1';
    })
    .catch(err => {
      console.error('Update Cart Error:', err);
      if (itemsContainer) itemsContainer.style.opacity = '1';
    });
  };


  // Add to cart form submission
  const productForm = document.getElementById('ProductForm');
  if(productForm) {
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      
      const formData = new FormData(productForm);
      const errorMsg = document.getElementById('ProductErrorMsg');
      
      // Basic validation for missing options could go here
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(res => {
        if(!res.ok) throw res;
        return res.json();
      })
      .then(item => {
        if(errorMsg) errorMsg.style.display = 'none';
        fetchCart();
        openDrawer();
      })
      .catch(err => {
        err.json().then(errorData => {
          if(errorMsg) {
            errorMsg.innerText = errorData.description || "Error adding item to cart";
            errorMsg.style.display = 'block';
          }
        });
      });
    });
  }

    // Quick Add function
  window.theme.addQuickItemToCart = function(formElement) {
    const formData = new FormData(formElement);
    const btn = formElement.querySelector('.quick-options-add-btn');
    if (btn) {
      btn.innerText = "ADDING...";
      btn.disabled = true;
    }
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(res => res.json())
    .then(item => {
      if (item.status && item.status >= 400) {
        if (btn) {
          btn.innerText = "ERROR / SOLD OUT";
          setTimeout(() => { btn.innerText = "ADD TO CART"; btn.disabled = false; }, 2000);
        }
        return;
      }
      
      fetchCart().then(() => {
        if (btn) {
          btn.innerText = "ADDED!";
          setTimeout(() => { btn.innerText = "ADD TO CART"; btn.disabled = false; }, 2000);
        }
        openDrawer();
      });
    })
    .catch(err => {
      console.error(err);
      if (btn) {
        btn.innerText = "ADD TO CART";
        btn.disabled = false;
      }
    });
  };


  // Quick Option Selection
  window.theme.selectQuickOption = function(btn, optionName, value) {
    const list = btn.closest('.quick-options-list');
    list.querySelectorAll('button').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    
    // Update hidden variant ID based on selected options
    const form = btn.closest('form');
    const productDataStr = form.querySelector('.quick-variant-id').getAttribute('data-product-json');
    if(!productDataStr) return;
    const product = JSON.parse(productDataStr);
    
        // Gather selected values
    const selectedOptions = [];
    form.querySelectorAll('.quick-options-list').forEach(list => {
      const activeBtn = list.querySelector('button.active') || list.querySelector('button');
      if (activeBtn) {
        selectedOptions.push(activeBtn.getAttribute('data-value'));
        // ensure it has active class if it was the fallback
        if(!activeBtn.classList.contains('active')) activeBtn.classList.add('active');
      }
    });

    
    // Find matching variant
    const variant = product.variants.find(v => {
      return selectedOptions.every((val, index) => v.options[index] === val);
    });
    
    if(variant) {
      form.querySelector('.quick-variant-id').value = variant.id;
      if(variant.available) {
        form.querySelector('.quick-options-add-btn').innerText = "ADD TO CART";
        form.querySelector('.quick-options-add-btn').disabled = false;
      } else {
        form.querySelector('.quick-options-add-btn').innerText = "SOLD OUT";
        form.querySelector('.quick-options-add-btn').disabled = true;
      }
    }
  };

  // Main Product Page Logic
  // Quantity adjusters
  const qtyMinus = document.getElementById('QtyMinus');
  const qtyPlus = document.getElementById('QtyPlus');
  const qtyInput = document.getElementById('ProductQuantity');
  
  if(qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', () => {
      let val = parseInt(qtyInput.value) || 1;
      if(val > 1) qtyInput.value = val - 1;
    });
  }
  if(qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', () => {
      let val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

  // Variant selector sync
  const optionSelects = document.querySelectorAll('.product-option-select');
  const optionBtns = document.querySelectorAll('.product-option-btn');
  const masterSelect = document.getElementById('ProductSelect');

  function updateMasterVariant() {
    if(!masterSelect || !window.productJSON) return;
    
    let selectedOptions = [];
    
    // We look at the actual selects and button swatches
    // Assume up to 3 options
    for(let i=1; i<=3; i++) {
      let val = null;
      // check if select exists for this option
      const sel = document.querySelector(`.product-option-select[data-index="option${i}"]`);
      if(sel) {
        val = sel.value;
      } else {
        // check if buttons exist
        const activeBtn = document.querySelector(`.product-option-btn[data-index="option${i}"].active`);
        if(activeBtn) val = activeBtn.getAttribute('data-value');
      }
      if(val) selectedOptions.push(val);
    }

    const variant = window.productJSON.variants.find(v => {
      return selectedOptions.every((val, index) => v.options[index] === val);
    });
    
    if(variant) {
      masterSelect.value = variant.id;
      document.getElementById('ProductPrice').innerText = 'R' + (variant.price / 100).toFixed(2);
      if(document.getElementById('ProductSku')) {
        document.getElementById('ProductSku').innerText = variant.sku || '';
      }
      
      const addBtn = document.getElementById('AddToCartBtn');
      if(variant.available) {
        addBtn.innerText = "ADD TO CART";
        addBtn.disabled = false;
      } else {
        addBtn.innerText = "SOLD OUT";
        addBtn.disabled = true;
      }
    }
  }

  optionSelects.forEach(sel => sel.addEventListener('change', updateMasterVariant));
  optionBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const group = document.querySelectorAll(`.product-option-btn[data-index="${btn.getAttribute('data-index')}"]`);
      group.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      updateMasterVariant();
    });
  });

  // Accordions
  document.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', () => {
      const content = header.nextElementSibling;
      const icon = header.querySelector('.acc-icon');
      if(content.style.display === 'none' || !content.style.display) {
        content.style.display = 'block';
        icon.innerText = '-';
      } else {
        content.style.display = 'none';
        icon.innerText = '+';
      }
    });
  });

  // Size chart modal
  const sizeChartTrigger = document.getElementById('SizeChartTrigger');
  const sizeChartModal = document.getElementById('SizeChartModal');
  const sizeChartClose = document.getElementById('SizeChartClose');

  if(sizeChartTrigger && sizeChartModal) {
    sizeChartTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      sizeChartModal.style.display = 'flex';
    });
    sizeChartClose.addEventListener('click', () => {
      sizeChartModal.style.display = 'none';
    });
    sizeChartModal.addEventListener('click', (e) => {
      if(e.target === sizeChartModal) {
        sizeChartModal.style.display = 'none';
      }
    });
  }

  // Image scroll observer
  const imageContainer = document.getElementById('ProductImageContainer');
  const indicators = document.querySelectorAll('.image-carousel-indicators .indicator');
  
  if(imageContainer && indicators.length > 0) {
    imageContainer.addEventListener('scroll', () => {
      let index = Math.round(imageContainer.scrollTop / imageContainer.clientHeight) || 0;
      let hIndex = Math.round(imageContainer.scrollLeft / imageContainer.clientWidth) || 0;
      let activeIndex = Math.max(index, hIndex);
      
      indicators.forEach((ind, i) => {
        if(i === activeIndex) ind.classList.add('active');
        else ind.classList.remove('active');
      });
    });
  }

})();
